// extracted by mini-css-extract-plugin
export default {"countCondition":"House_countCondition__MsovP","download":"House_download__9k8NA"};